//Requests.js

import {
  BrandButton,
  BrandOutlinedButton,
  ThemePrimaryButton,
  ProjectVioletButton,
  TextCancelButton,
  ErrorContainedButton,
} from '../button';
import { getStripe } from '../../utils/stripeClient';
import React, { useState, useEffect } from 'react';
import { acmePageHeaderContentSx } from '../../theme/acmeTheme';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem as MuiMenuItem,
  TableFooter,
  TablePagination,
  Avatar,
  Chip
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  PictureAsPdf as PictureAsPdfIcon,
  AccessTime as AccessTimeIcon,
  Assignment as AssignmentIcon
} from '@mui/icons-material';
import Autocomplete from '@mui/material/Autocomplete';
import { getCode } from 'country-list';
import { TableActionsMenu, TableActionsMenuButton, MenuItem as UiMenuItem, destructiveMenuItemSx, stopTableRowClick } from '../ui';
import { getIconByMimeType } from '../../iconMap';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Collapse from '@mui/material/Collapse';
import axios from 'axios';
import { useOutletContext, useLocation } from 'react-router-dom';
import RequestForm from '../RequestForm';
import PageSnackbars from '../common/PageSnackbars';
import { usePageSnackbar } from '../common/usePageSnackbar';
import { TableEmptyRow } from '../ui';
import {
  countriesList,
  currencies,
  services,
  objectives,
  ageRanges,
  genders,
  contactDatabases,
  emptyFormData,
  statusOptions,
  statusColors,
  paymentStatusOptions,
} from './requestsConstants';
import { Section, MultiSelectField } from './RequestsFormWidgets';
import { applyFilters, getUniqueFieldValues } from './requestsFiltering';
import { transformForEdit, canEditRequest } from './requestsModel';
import { downloadRequestProjectPdf, downloadRequestHistoryPdf } from './requestsPdf';
import { isAdminRole, isAdminOrManagerRole, ROLE_USER, normalizeRole } from '../../utils/userRoles';

export default function Requests() {
  const { requests, setRequests, user, setUpdatedRequests } = useOutletContext();
  const location = useLocation();
  
  const [filters, setFilters] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    phoneNumber: '',
    email: '',
    chosenService: '',
    status: '',
    projectName: '',
    createdDate: null,
    paidDate: null,
    deadline: null
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [closeProjectDialogOpen, setCloseProjectDialogOpen] = useState(false);
  const [addProjectDialogOpen, setAddProjectDialogOpen] = useState(false);

  const [formData, setFormData] = useState(emptyFormData);
  const [allCities, setAllCities] = useState([]);
  const { setSuccessMessage, setErrorMessage, snackbarProps } = usePageSnackbar();
  const [showHistory, setShowHistory] = useState(false);
  
  const [sendMailDialogOpen, setSendMailDialogOpen] = useState(false);
  const [mailRecipient, setMailRecipient] = useState('');
  const [mailSubject, setMailSubject] = useState('');
  const [mailBody, setMailBody] = useState('');
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [sendingMail, setSendingMail] = useState(false);
  
  const [emailAccounts, setEmailAccounts] = useState([]);
  const [mailFrom, setMailFrom] = useState('');

  // Cities filtered by selected countries (see form)
  const selectedCountryCodes = formData.countries.map(name => getCode(name)).filter(Boolean);
  const filteredCities = selectedCountryCodes.length > 0 ? allCities.filter(city => selectedCountryCodes.includes(city.country)) : [];

  // Add new state for edit mode
  const [isEditMode, setIsEditMode] = useState(false);
  const [confirmEditDialogOpen, setConfirmEditDialogOpen] = useState(false);

  // Add new state for tracking form changes
  const [hasFormChanges, setHasFormChanges] = useState(false);

  // Add new state for form submission
  const [formRef, setFormRef] = useState(null);

  // Add state for selected row
  const [selected, setSelected] = useState(null);

  const updateRowColor = 'rgba(255, 235, 59, 0.18)'; // прозрачный жёлтый для обновлений

  // Автоматическое открытие диалога Add Project при переходе с Pricing
  useEffect(() => {
    if (location.state?.autoOpenAddProject) {
      setAddProjectDialogOpen(true);
      // Предзаполняем выбранную услугу если она передана
      if (location.state?.selectedService) {
        const selectedService = location.state.selectedService;
        let chosenService = 'Digital-marketing'; // по умолчанию
        
        // Определяем правильную категорию услуги
        if (selectedService === 'SEO') {
          chosenService = 'SEO';
        } else if (services.filter((s) => s !== 'SEO').includes(selectedService)) {
          chosenService = 'Digital-marketing';
        }
        
        setFormData(prev => ({
          ...prev,
          chosenService: chosenService,
          serviceSelection: chosenService === 'SEO' ? [] : [selectedService] // для SEO не нужен serviceSelection
        }));
      }
      
      // Очищаем state чтобы избежать повторного срабатывания
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    fetch('/api/requests')
      .then(res => res.json())
      .then(data => {
        console.log('Fetched requests:', data);
        setRequests(data);
      })
      .catch(err => {
        console.error('Failed to fetch requests:', err);
        setErrorMessage('Failed to fetch requests.');
      });
  }, [setErrorMessage, setRequests]);

  // Load mail accounts for the Send mail dialog (same pattern as SmtpTab.jsx)
  useEffect(() => {
    axios.get('/api/mail/accounts', { withCredentials: true })
      .then(res => {
        setEmailAccounts(res.data || []);
        if (res.data && res.data.length > 0) {
          setMailFrom(res.data[0].email);
        }
      })
      .catch(err => console.error('Failed to fetch email accounts', err));
  }, []);

  useEffect(() => {
    fetch('/api/cities')
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return response.json();
      })
      .then(data => setAllCities(data))
      .catch(err => {
        console.error('Failed to load city data:', err);
        setErrorMessage('Failed to load city data.');
      });
  }, [setErrorMessage]);

  const filteredRequests = applyFilters(requests, filters);
  const totalFiltered = filteredRequests.length;
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const pageItems = filteredRequests.slice(startIndex, endIndex);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    const newVal = parseInt(event.target.value, 10);
    setRowsPerPage(newVal);
    setPage(0);
  };

  function handleMenuOpen(e, req) {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedRequest(req);
  }
  function handleMenuClose() {
    setAnchorEl(null);
  }
  
function handleSendMailOpen() {
  if (!selectedRequest) return;
  setMailRecipient(selectedRequest.email);
  const notPaidOrClosed = !['Closed', 'In processing', 'Pending payment'].includes(
    selectedRequest.status
  );
  if (
    isAdminOrManagerRole(user.role) &&
    notPaidOrClosed &&
    (selectedRequest.status === 'New' || selectedRequest.status === 'Pending')
  ) {
    updateRequestField(selectedRequest, { status: 'Communication' });
    setSelectedRequest((prev) => ({ ...prev, status: 'Communication' }));
  }
  setMailSubject('Payment Confirmation');
  // ???? Email Content ????????? ?????? � ???????????? ?????? ?????? ?????,
  // ??????? ????? ??????? ? ????????? ?????? ?? ???????.
  setMailBody('');
  // ?????????? ?????? ??????
  setAttachedFiles([]);
  setSendingMail(false); // Сбрасываем состояние загрузки
  setSendMailDialogOpen(true);
}

    // ??????????? ??? drag & drop
  const handleDragOver = (e) => {
  e.preventDefault();
};
  
  const handleDrop = (e) => {
  e.preventDefault();
  const files = Array.from(e.dataTransfer.files);
  setAttachedFiles(prev => [...prev, ...files]);
};
  
// ??????? ???????? ????? ?? attachedFiles
const handleRemoveSendMailFile = (index) => {
  setAttachedFiles(prev => prev.filter((_, i) => i !== index));
};

// ??????? ?????? ?????? (??? ????? ? ????? input)
const handleSendMailFileChange = (e) => {
  const files = Array.from(e.target.files);
  setAttachedFiles(prev => [...prev, ...files]);
  // ????? ???????? ???? input, ????? ??? ?????? ???? ?? ????? onChange ???????? ?????
  e.target.value = "";
};

  // --- ???????? ---
  function handleDeleteConfirmOpen() {
    setDeleteDialogOpen(true);
  }
  function handleDeleteConfirmClose() {
    setDeleteDialogOpen(false);
  }
  async function handleDeleteRequest() {
    if (!selectedRequest) return;
    const requestId = selectedRequest.id || selectedRequest._id;
    try {
      const res = await fetch(`/api/requests/${requestId}`, { method: 'DELETE' });
      if (!res.ok) throw new Error(`Delete error: ${res.status}`);
      setRequests(prev => prev.filter(r => (r.id || r._id) !== requestId));
      setSuccessMessage('Request deleted successfully.');
    } catch (err) {
      console.error(err);
      setErrorMessage('Failed to delete request.');
    } finally {
      setDeleteDialogOpen(false);
      setSelectedRequest(null);
      setAnchorEl(null);
    }
  }
  
    // ?????????? ?????? ???? ??????? (????????, ??????, ????, ??????)
  async function updateRequestField(reqItem, updateObj, updatedRequest) {
    const requestId = reqItem.id || reqItem._id;
    try {
      const response = await fetch(`/api/requests/${requestId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateObj)
      });
      if (!response.ok) throw new Error(`HTTP error ${response.status}`);
      const updatedReq = await response.json();
      
      updatedReq.updated = true;
      setUpdatedRequests(prev => new Set([...prev, requestId]));
      
      // Находим существующий запрос, чтобы сохранить поля, которые могли не вернуться с сервера
      setRequests(prev => {
        return prev.map(r => {
          if (String(r.id || r._id) === requestId) {
            // Сохраняем userId объект, если в обновленном запросе он отсутствует или неполный
            if (!updatedReq.userId || !updatedReq.userId.avatarUrl) {
              updatedReq.userId = r.userId;
            }
            return updatedReq;
          }
          return r;
        });
      });
     
      setSuccessMessage('Request updated successfully.');
    } catch (err) {
      console.error('Update error:', err);
      setErrorMessage('Failed to update request.');
    }
  }

  // --- ?????? (View/Edit) ---
function handleDetailOpen(req) {
  const requestToEdit = req || selectedRequest;
  if (!requestToEdit) return;

  // Reset edit mode and form changes
  setIsEditMode(false);
  setHasFormChanges(false);

  // Делаем копию объекта запроса, чтобы сохранить все его данные
  const requestCopy = { ...requestToEdit };
  
  // Explicitly preserve the userId with all its properties
  console.log("Original userId: ", requestCopy.userId);
  
  // Ensure we preserve the userId when setting selectedRequest
  setSelectedRequest(requestCopy);
  
  // Set the selected row ID - this highlights the selected row while keeping the row's status-based styling
  const rowId = String(requestCopy.id || requestCopy._id);
  setSelected(rowId);
  
  // Transform the request data while preserving userId
  const transformedData = transformForEdit(requestCopy);
  setFormData(transformedData);

  // Проверяем, не просмотрена ли уже заявка этим пользователем
  const userIdStr = String(user?._id);
  const isViewedByCurrentUser = Array.isArray(requestToEdit.viewedBy) && 
    requestToEdit.viewedBy.some(v => v.userId && String(v.userId) === userIdStr);

  // Обновляем список просмотревших локально, если нужно
  if (user && !isViewedByCurrentUser) {
    const updatedRequest = {
      ...requestCopy,
      viewedBy: [...(requestCopy.viewedBy || []), { userId: user._id, lastViewedAt: new Date() }],
    };
    setRequests(prev => 
      prev.map(r => {
        if (String(r._id) === String(updatedRequest._id)) {
          // Сохраняем userId объект при обновлении
          return { ...updatedRequest, userId: r.userId };
        }
        return r;
      })
    );
  }

  if (requestToEdit.status === 'New' && isAdminOrManagerRole(user?.role)) {
    updateRequestField(requestToEdit, { status: 'Pending' });
    setFormData(prev => ({ ...prev, status: 'Pending' }));
  }

  // Сохраняем userId перед отправкой PATCH-запроса
  const originalUserId = requestCopy.userId;
  console.log("originalUserId before fetch: ", originalUserId);

  fetch(`/api/requests/${requestToEdit.id || requestToEdit._id}/view`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (response.ok) return response.json();
      throw new Error('Error marking request as viewed');
    })
    .then(updatedReq => {
      console.log("Received from server: ", updatedReq);
      console.log("updatedReq.userId: ", updatedReq.userId);
      console.log("originalUserId: ", originalUserId);
      
      // Если сервер вернул запрос без userId или без avatarUrl, восстанавливаем оригинальный userId
      if (!updatedReq.userId || !updatedReq.userId.avatarUrl) {
        console.log("Restoring originalUserId");
        updatedReq.userId = originalUserId;
      }
      
      // Обновляем запрос в списке, сохраняя userId
      setRequests(prev => prev.map(r => {
        if (String(r._id) === String(updatedReq._id)) {
          const result = { 
            ...updatedReq, 
            userId: updatedReq.userId && updatedReq.userId.avatarUrl 
              ? updatedReq.userId 
              : r.userId 
          };
          console.log("Updated request in list: ", result);
          return result;
        }
        return r;
      }));
      
      // Обновляем выбранный запрос, если это необходимо
      setSelectedRequest(prev => {
        if (prev && String(prev._id) === String(updatedReq._id)) {
          return { 
            ...updatedReq, 
            userId: updatedReq.userId && updatedReq.userId.avatarUrl 
              ? updatedReq.userId 
              : prev.userId 
          };
        }
        return prev;
      });
    })
    .catch((err) => {
      console.error('Error marking request as viewed:', err);
    });

  setDetailDialogOpen(true);
  setAnchorEl(null);
}
  function handleDetailClose() {
    setDetailDialogOpen(false);
    setFormData(emptyFormData);
    setSelected(null);
  }

  // ????????? ??????? ????? ?????????????? ???????
async function handleUpdateSubmit(e) {
  e?.preventDefault();
  if (!selectedRequest) return;

  if (isEditMode && normalizeRole(user.role) === ROLE_USER) {
    setConfirmEditDialogOpen(true);
    return;
  }

  if (!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode) {
    setErrorMessage('You do not have permission to edit this request');
    return;
  }

  const requestId = selectedRequest.id || selectedRequest._id;
  let updatedFormData = { ...formData };

  // If editing from Pending payment status, change to Communication and clear price
  if (selectedRequest.status === 'Pending payment' && isEditMode) {
    updatedFormData = {
      ...updatedFormData,
      status: 'Communication',
      price: '',
      paymentStatus: ''
    };
  }
  
  const priceNum = Number(updatedFormData.price) || 0;
  let newStatus = updatedFormData.status;
  let statusChanged = false;
  
  // ЛОГИКА АВТОМАТИЧЕСКИХ ПЕРЕХОДОВ СТАТУСОВ:
  // 1. Если установлена цена > 0 и текущий статус позволяет переход к оплате
  if (
    priceNum > 0 &&
    !['Closed', 'In processing', 'Pending payment'].includes(newStatus)
  ) {
    newStatus = 'Pending payment';
    statusChanged = true;
  }
  // 2. Если цена убирается (= 0) из статуса "Pending payment" -> возврат к коммуникации
  else if (priceNum === 0 && newStatus === 'Pending payment') {
    newStatus = 'Communication';
    statusChanged = true;
  }

  // Применяем новый статус к обновляемым данным
  updatedFormData = {
    ...updatedFormData,
    status: newStatus
  };

  try {
    const fileArrays = ['graphicFiles', 'webDevFiles', 'businessFiles'];
    const hasNewFiles = fileArrays.some(fileArrayName => 
      updatedFormData[fileArrayName] && updatedFormData[fileArrayName].some(f => f.file)
    );
    
    let response;
    if (hasNewFiles) {
      const formDataToSend = new FormData();
      // Add all form data except file arrays
      for (let key in updatedFormData) {
        if (!fileArrays.includes(key)) {
          formDataToSend.append(key, updatedFormData[key]);
        }
      }
      
      // Handle each file array separately
      fileArrays.forEach(fileArrayName => {
        if (updatedFormData[fileArrayName] && updatedFormData[fileArrayName].length > 0) {
          const existingFiles = updatedFormData[fileArrayName].filter(file => !file.file);
          const existingFieldName = `existing${fileArrayName.charAt(0).toUpperCase() + fileArrayName.slice(1)}`;
          formDataToSend.append(existingFieldName, JSON.stringify(existingFiles));
          
          updatedFormData[fileArrayName].forEach(fileObj => {
            if (fileObj.file) {
              formDataToSend.append(fileArrayName, fileObj.file, fileObj.name);
            }
          });
        }
      });
      response = await fetch(`/api/requests/${requestId}`, {
        method: 'PUT',
        body: formDataToSend
      });
    } else {
      const payload = { ...updatedFormData };
      
      // Process all file arrays
      fileArrays.forEach(fileArrayName => {
        if (payload[fileArrayName] && payload[fileArrayName].length > 0) {
          payload[fileArrayName] = payload[fileArrayName].map(file => ({
            path: file.path,
            originalName: file.originalName,
            mimeType: file.mimeType
          }));
        }
      });
      response = await fetch(`/api/requests/${requestId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    const updatedReq = await response.json();
    setRequests(prev => prev.map(r => {
      if ((r.id || r._id) === requestId) {
        // Сохраняем userId, если он отсутствует или неполный в обновленных данных
        if (!updatedReq.userId || !updatedReq.userId.avatarUrl) {
          updatedReq.userId = r.userId;
        }
        return updatedReq;
      }
      return r;
    }));
    
    // Показываем сообщение об успешном обновлении с дополнительной информацией о смене статуса
    if (statusChanged) {
      if (newStatus === 'Pending payment') {
        setSuccessMessage(`Request updated successfully. Status changed to "Pending payment" because price was set.`);
      } else if (newStatus === 'Communication') {
        setSuccessMessage(`Request updated successfully. Status changed to "Communication" because price was removed.`);
      } else {
        setSuccessMessage(`Request updated successfully. Status changed to "${newStatus}".`);
      }
    } else {
      setSuccessMessage('Request updated successfully.');
    }
    
    setDetailDialogOpen(false);
    setFormData(emptyFormData);
    setIsEditMode(false);
  } catch (err) {
    console.error('Update error:', err);
    setErrorMessage('Failed to update request.');
  }
}


  // ??????????? ????????? ?????
  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    
    setFormData(prev => {
      const newFormData = {
        ...prev,
        [name]: newValue
      };
      
      // Check if any values are different from the original request
      if (isEditMode) {
        const hasChanges = Object.keys(newFormData).some(key => 
          newFormData[key] !== selectedRequest[key]
        );
        setHasFormChanges(hasChanges);
      }
      
      return newFormData;
    });
  }
  function handleMultiSelectChange(fieldName) {
    return (event) => {
      setFormData(prev => ({
        ...prev,
        [fieldName]: event.target.value
      }));
    };
  }
  const handleRemoveFile = (fileArrayName, index) => {
    setFormData(prev => {
      const updatedFiles = [...prev[fileArrayName]];
      updatedFiles.splice(index, 1);
      return { ...prev, [fileArrayName]: updatedFiles };
    });
  };
  
  function handleAutocompleteChange(fieldName) {
    return (event, newValue) => {
      setFormData(prev => ({
        ...prev,
        [fieldName]: newValue
      }));
    };
  }
  function handleAutocompleteChangeForCities(event, newValue) {
    const cityNames = newValue.map(cityObj => cityObj.name);
    setFormData(prev => ({
      ...prev,
      cities: cityNames
    }));
  }
  function handleFileChange(fileArrayName) {
    return (e) => {
      const newFiles = Array.from(e.target.files).map(file => ({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
        type: file.type
      }));
      setFormData(prev => ({
        ...prev,
        [fileArrayName]: [...prev[fileArrayName], ...newFiles]
      }));
    };
  }
async function handleSendMail() {
  // Защита от повторных нажатий
  if (sendingMail) {
    return;
  }

  if (!mailFrom || !mailRecipient || !mailSubject) {
    alert("Please fill in all required fields.");
    return;
  }

  // ?????????? ?????? ??????? ?? ?????? (???? ????? ???????? ?? mailFrom)
  const accountId = emailAccounts.length > 0 ? emailAccounts[0]._id : null;
  if (!accountId) {
    alert("No sending email account available.");
    return;
  }
  
  setSendingMail(true);
  try {
    // ????????? FormData � ?????, ????? ???? ??? ?????? ???????? ? ???, ??????? ?? ??????? ?? ??????? (�attachments�)
    const data = new FormData();
    data.append("from", mailFrom);
    data.append("to", mailRecipient);
    data.append("subject", mailSubject);
    data.append("htmlContent", mailBody);
    attachedFiles.forEach(file => {
      // ???????? ????????: input ?????? ????? name="attachments" (? multer ????? ??????? ??? ????)
      data.append("attachments", file);
    });
    
    await axios.post(`/api/mail/messages/${accountId}/send`, data, {
      withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" }
    });
    setSuccessMessage("Email sent successfully!");
    setSendMailDialogOpen(false);
  } catch (error) {
    console.error("Error sending email:", error);
    setErrorMessage("Failed to send email.");
  } finally {
    setSendingMail(false);
  }
}

  // --- ???????? ??????? ---
  function handleCloseProjectOpen() {
    setCloseProjectDialogOpen(true);
  }
  function handleCloseProjectClose() {
    setCloseProjectDialogOpen(false);
  }
  async function handleConfirmCloseProject() {
    if (!selectedRequest) return;
    
    // Сохраняем текущие значения price и paymentStatus
    const currentPrice = selectedRequest.price;
    const currentPaymentStatus = selectedRequest.paymentStatus;
    
    // Обновляем запрос на сервере
    await updateRequestField(selectedRequest, { 
      status: 'Closed',
      // Явно отправляем текущие значения, чтобы они не потерялись
      price: currentPrice,
      paymentStatus: currentPaymentStatus
    });
    
    setCloseProjectDialogOpen(false);
    
    if (detailDialogOpen) {
      // Обновляем локальное состояние с сохранением price и paymentStatus
      setFormData(prev => ({ 
        ...prev, 
        status: 'Closed',
        price: currentPrice,
        paymentStatus: currentPaymentStatus
      }));
      
      // Также обновляем локальное состояние selectedRequest
      setSelectedRequest(prev => ({
        ...prev,
        status: 'Closed',
        price: currentPrice,
        paymentStatus: currentPaymentStatus
      }));
    }
  }

  // --- Pay (Stripe checkout) ---
  async function handlePayRequest(reqItem) {
    try {
      if (!user.billingAddress || !user.billingCity || !user.billingPostalCode || !user.billingCountry) {
        setErrorMessage(
          'Please complete your billing information (address, city, postal code, and country) in Billing settings before proceeding with payment.'
        );
        return;
      }

      const amountInCents = Number(reqItem.price) * 100;
      const response = await fetch('/api/request-payment/checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amountInCents,
          currency: 'eur',
          requestId: reqItem.id,
          firstName: reqItem.firstName,
          lastName: reqItem.lastName,
          email: reqItem.email,
          isCompanyPayment: false,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || 'Failed to initiate payment');
        return;
      }

      const { id: sessionId } = await response.json();
      const stripe = await getStripe();
      if (!stripe) {
        setErrorMessage('Stripe is not configured. Set REACT_APP_STRIPE_PUBLIC_KEY in frontend/.env');
        return;
      }
      const { error } = await stripe.redirectToCheckout({ sessionId });
      if (error) {
        console.error('Stripe redirect error:', error);
        setErrorMessage('Error redirecting to payment page');
      }
    } catch (error) {
      console.error('Payment error:', error);
      setErrorMessage('An error occurred during payment processing.');
    }
  }

  const handleDownloadProject = () => {
    downloadRequestProjectPdf(selectedRequest).catch((err) => {
      console.error('PDF export failed:', err);
      setErrorMessage('Failed to export project PDF.');
    });
  };

  const handleDownloadHistory = () => downloadRequestHistoryPdf(selectedRequest);

  // Add confirmation dialog component
  const ConfirmEditDialog = () => (
    <Dialog
      open={confirmEditDialogOpen}
      onClose={() => setConfirmEditDialogOpen(false)}
      aria-labelledby="edit-dialog-title"
      aria-describedby="edit-dialog-description"
    >
      <DialogTitle id="edit-dialog-title">
        Confirm Changes
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="edit-dialog-description">
          Are you sure you want to modify the request? These changes may affect the price of the service.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <TextCancelButton onClick={() => setConfirmEditDialogOpen(false)}>Cancel</TextCancelButton>
        <ThemePrimaryButton 
          onClick={() => {
            handleConfirmEdit();
            setConfirmEditDialogOpen(false);
          }} 
        >
          Confirm Changes
        </ThemePrimaryButton>
      </DialogActions>
    </Dialog>
  );

  // Add function to handle edit confirmation
  const handleConfirmEdit = async () => {
    const requestId = selectedRequest.id || selectedRequest._id;
    const updatedFormData = {
      ...formData,
      status: 'Communication', // Изменено с 'Pending' на 'Communication'
      price: '',
      paymentStatus: ''
    };

    try {
      const response = await fetch(`/api/requests/${requestId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedFormData)
      });

      if (!response.ok) throw new Error(`HTTP error ${response.status}`);
      const updatedReq = await response.json();
      setRequests(prev => prev.map(r => {
        if ((r.id || r._id) === requestId) {
          // Сохраняем userId при обновлении
          if (!updatedReq.userId || !updatedReq.userId.avatarUrl) {
            updatedReq.userId = r.userId;
          }
          return updatedReq;
        }
        return r;
      }));
      setSuccessMessage('Request updated successfully.');
      setDetailDialogOpen(false);
      setFormData(emptyFormData);
      setIsEditMode(false);
    } catch (err) {
      console.error('Update error:', err);
      setErrorMessage('Failed to update request.');
    }
  };

  // Add function to handle edit mode exit
  function handleCloseEdit() {
    setIsEditMode(false);
    setHasFormChanges(false);
    setFormData(transformForEdit(selectedRequest)); // Reset form to original data
  }

  // Add new function to handle form submission
  const handleAddProjectSubmit = () => {
    if (formRef) {
      // Trigger form submission
      formRef.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  };

  // Add fetchRequests function
  const fetchRequests = async () => {
    try {
      const response = await fetch('/api/requests', {
        credentials: 'include'
      });
      if (!response.ok) throw new Error('Failed to fetch requests');
      const data = await response.json();
      
      // Сохраняем userId информацию при обновлении списка заявок
      setRequests(prev => {
        // Создаем карту существующих запросов для быстрого доступа
        const existingRequestsMap = new Map();
        prev.forEach(req => {
          existingRequestsMap.set(String(req.id || req._id), req);
        });
        
        // Обрабатываем каждый запрос из новых данных
        return data.map(newReq => {
          const reqId = String(newReq.id || newReq._id);
          const existingReq = existingRequestsMap.get(reqId);
          
          // Если запрос существует и у нового нет userId (или нет аватарки), используем старый userId
          if (existingReq && (!newReq.userId || !newReq.userId.avatarUrl) && existingReq.userId) {
            return { ...newReq, userId: existingReq.userId };
          }
          
          return newReq;
        });
      });
    } catch (error) {
      console.error('Error fetching requests:', error);
      setErrorMessage('Failed to fetch requests');
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, ...acmePageHeaderContentSx }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Projects
        </Typography>
        <BrandButton
        variant="contained"
        primaryHover="light"
        startIcon={<AddIcon />}
        onClick={() => setAddProjectDialogOpen(true)}
      >
        Add Project
      </BrandButton>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Avatar</strong></TableCell>
              <TableCell><strong>First Name</strong></TableCell>
              <TableCell><strong>Last Name</strong></TableCell>
              <TableCell><strong>Company</strong></TableCell>
              <TableCell><strong>Phone</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Project Name</strong></TableCell>
              <TableCell><strong>Created</strong></TableCell>
              <TableCell><strong>Service</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Price</strong></TableCell>
              <TableCell><strong>Payment</strong></TableCell>
              <TableCell><strong>Invoice</strong></TableCell>
              <TableCell><strong>Paid Date</strong></TableCell>
              <TableCell><strong>Deadline</strong></TableCell>
              <TableCell><strong>Actions</strong></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{/* Avatar filter (????? ???????? ??????) */}</TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'firstName')}
                  value={filters.firstName}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, firstName: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, firstName: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'lastName')}
                  value={filters.lastName}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, lastName: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, lastName: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'companyName')}
                  value={filters.companyName}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, companyName: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, companyName: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'phoneNumber')}
                  value={filters.phoneNumber}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, phoneNumber: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, phoneNumber: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'email')}
                  value={filters.email}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, email: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, email: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'projectName')}
                  value={filters.projectName}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, projectName: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, projectName: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <DatePicker
                  value={filters.createdDate || null}
                  onChange={(newValue) => setFilters(prev => ({ ...prev, createdDate: newValue }))}
                  slots={{ 
                    textField: TextField 
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "small",
                      placeholder: "Select date"
                    }
                  }}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'chosenService')}
                  value={filters.chosenService}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, chosenService: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, chosenService: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  freeSolo
                  options={getUniqueFieldValues(requests, 'status')}
                  value={filters.status}
                  onChange={(event, newValue) =>
                    setFilters(prev => ({ ...prev, status: newValue || '' }))
                  }
                  onInputChange={(event, newInputValue) =>
                    setFilters(prev => ({ ...prev, status: newInputValue }))
                  }
                  renderInput={(params) => <TextField {...params} variant="standard" placeholder="Filter" />}
                />
              </TableCell>
              <TableCell>{/* Price filter */}</TableCell>
              <TableCell>{/* Payment filter */}</TableCell>
              <TableCell>{/* Invoice filter */}</TableCell>
              <TableCell>
                <DatePicker
                  value={filters.paidDate || null}
                  onChange={(newValue) => setFilters(prev => ({ ...prev, paidDate: newValue }))}
                  slots={{ 
                    textField: TextField 
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "small",
                      placeholder: "Select date"
                    }
                  }}
                />
              </TableCell>
              <TableCell>
                <DatePicker
                  value={filters.deadline || null}
                  onChange={(newValue) => setFilters(prev => ({ ...prev, deadline: newValue }))}
                  slots={{ 
                    textField: TextField 
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "small",
                      placeholder: "Select date"
                    }
                  }}
                />
              </TableCell>
              <TableCell>{/* Actions filter */}</TableCell>
            </TableRow>
          </TableHead>
         <TableBody>
  {pageItems.length === 0 ? (
    <TableEmptyRow
      colSpan={16}
      icon={AssignmentIcon}
      title="No projects found"
      description="Start your marketing journey by submitting your first project request. Our team will review your requirements and provide customized solutions for your business needs."
      hint='Click "Add Project" above to create your first project request.'
    />
  ) : (
    pageItems.map(req => {
    const rowId = String(req.id || req._id);
    const userIdStr = String(user?._id);
    // Новый формат viewedBy: [{ userId, lastViewedAt }]
    let myView = (req.viewedBy || []).find(v => v.userId && String(v.userId) === userIdStr);
    const lastViewedAt = myView ? new Date(myView.lastViewedAt) : null;
    const lastUpdatedAt = req.lastUpdatedAt ? new Date(req.lastUpdatedAt) : null;
    const lastUpdatedBy = req.lastUpdatedBy ? String(req.lastUpdatedBy) : null;
    let isNotViewed = false;
    let isUpdate = false;
    if (!lastViewedAt || (lastUpdatedAt && lastViewedAt < lastUpdatedAt)) {
      if (lastUpdatedBy === userIdStr) {
        isUpdate = true;
      } else {
        isNotViewed = true;
      }
    }
    const rowStyle = {
      backgroundColor:
        req.status === 'Closed'
          ? 'rgba(0, 128, 0, 0.1)'
          : isNotViewed
          ? 'rgba(108, 68, 207, 0.1)'
          : isUpdate
          ? updateRowColor
          : 'inherit'
    };

    console.log("Row:", req._id, "viewedBy:", req.viewedBy, "myId:", userIdStr, "isNotViewed:", isNotViewed, "isUpdate:", isUpdate);

    // Определяем, должна ли строка иметь особый стиль (удалена пользователем)
    const isDeletedByUser = req.isDeletedByUser;
    
    return (
      <TableRow
        key={rowId}
        hover
        onClick={() => handleDetailOpen(req)}
        selected={selected === rowId}
        sx={{
          cursor: 'pointer',
          bgcolor: isDeletedByUser 
            ? 'rgba(233, 30, 99, 0.08)' 
            : rowStyle.backgroundColor, // Apply row background color here
          position: 'relative',
          ...(lastUpdatedAt && lastViewedAt && lastUpdatedAt > lastViewedAt ? {
            // Если строка не просмотрена, делаем ее более заметной
            '&::before': {
              content: '""',
              position: 'absolute',
              left: '0',
              top: '0',
              width: '5px',
              height: '100%',
              backgroundColor: 'blue',
            }
          } : {})
        }}
      >
        <TableCell>
          <Avatar src={req.userId?.avatarUrl || ''}>
            {req.userId?.firstName ? req.userId.firstName.charAt(0) : ''}
          </Avatar>
        </TableCell>
        <TableCell>{req.firstName}</TableCell>
        <TableCell>{req.lastName}</TableCell>
        <TableCell>{req.companyName}</TableCell>
        <TableCell>{req.phoneNumber}</TableCell>
        <TableCell>{req.email}</TableCell>
        <TableCell>{req.projectName}</TableCell>
        <TableCell>
          {req.createdAt ? new Date(req.createdAt).toLocaleDateString() : '-'}
        </TableCell>
        <TableCell>{req.chosenService}</TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {statusOptions.find(option => option.value === req.status)?.icon}
            {req.status}
            {/* Показываем метку о удалении пользователем для админов/менеджеров */}
            {isAdminOrManagerRole(user.role) && req.isDeletedByUser && (
              <Chip 
                size="small"
                label="Deleted by user" 
                color="error" 
                variant="outlined"
                sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
              />
            )}
          </Box>
        </TableCell>
        <TableCell>{req.price ? `\u20AC ${req.price}` : '-'}</TableCell>
        <TableCell>
          {normalizeRole(user.role) === ROLE_USER ? (
            // Для обычных пользователей
            req.price && Number(req.price) > 0 && req.paymentStatus !== 'Paid' && req.status !== 'Closed' ? (
              // Если есть цена, не оплачено и не закрыто - показываем кнопку Pay
              <ThemePrimaryButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePayRequest(req);
                }}
              >
                Pay
              </ThemePrimaryButton>
            ) : (
              // Иначе показываем статус "Paid" или "-"
              req.paymentStatus === 'Paid' ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {paymentStatusOptions.find(option => option.value === 'Paid')?.icon}
                  Paid
                </Box>
              ) : req.status === 'Closed' && req.price > 0 ? (
                // Для закрытых запросов с ценой показываем статус (Paid или Waiting)
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {paymentStatusOptions.find(option => option.value === (req.paymentStatus || 'Waiting'))?.icon}
                  {req.paymentStatus || 'Waiting'}
                </Box>
              ) : '-'
            )
          ) : (
            // Для админов и менеджеров
            req.price && Number(req.price) > 0 ? (
              // Если есть цена, показываем статус
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {paymentStatusOptions.find(option => option.value === (req.paymentStatus || 'Waiting'))?.icon}
                {req.paymentStatus || 'Waiting'}
              </Box>
            ) : req.status === 'Closed' && req.paymentStatus ? (
              // Для закрытых запросов показываем статус, если он есть
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {paymentStatusOptions.find(option => option.value === (req.paymentStatus || 'Waiting'))?.icon}
                {req.paymentStatus || 'Waiting'}
              </Box>
            ) : '-'
          )}
        </TableCell>
        <TableCell>
          {(req.invoiceUrl || req.invoicePath) ? (
            <IconButton
              component="a"
              href={`/api/invoices/request/${req._id}`}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
            >
              <PictureAsPdfIcon />
            </IconButton>
          ) : '-'}
        </TableCell>

        <TableCell>
          {req.paidAt ? new Date(req.paidAt).toLocaleDateString() : '-'}
        </TableCell>
        <TableCell>
          {req.projectDeadline ? (
            <Box sx={{ 
              color: new Date(req.projectDeadline) < new Date() && req.status !== 'Closed' ? 'error.main' : 'text.primary',
              fontWeight: new Date(req.projectDeadline) < new Date() && req.status !== 'Closed' ? 'bold' : 'normal'
            }}>
              {new Date(req.projectDeadline).toLocaleDateString()}
            </Box>
          ) : '-'}
        </TableCell>
        <TableCell onClick={stopTableRowClick}>
          <TableActionsMenuButton
            ariaLabel="Project actions"
            onClick={(e) => handleMenuOpen(e, req)}
          />
        </TableCell>
      </TableRow>
    );
  })
  )}
</TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={totalFiltered}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200, 500]}
                labelRowsPerPage="Rows per page"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* ???? ? ??????????????? ?????????? */}
      <TableActionsMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <UiMenuItem onClick={() => handleDetailOpen()}>View / Edit</UiMenuItem>
        <UiMenuItem onClick={() => handleDownloadProject()}>Download Project</UiMenuItem>
        <UiMenuItem onClick={() => handleDownloadHistory()}>Download History</UiMenuItem>
        <UiMenuItem onClick={handleCloseProjectOpen}>Close project</UiMenuItem>
        {isAdminOrManagerRole(user?.role) && (
          <UiMenuItem onClick={handleSendMailOpen}>Send mail</UiMenuItem>
        )}
        <UiMenuItem onClick={handleDeleteConfirmOpen} sx={destructiveMenuItemSx}>Delete</UiMenuItem>
      </TableActionsMenu>

      {/* ?????? ????????????? ???????? */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteConfirmClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this request?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <TextCancelButton onClick={handleDeleteConfirmClose}>Cancel</TextCancelButton>
          <ErrorContainedButton onClick={handleDeleteRequest}>Delete</ErrorContainedButton>
        </DialogActions>
      </Dialog>

      {/* ?????? ????????????? ???????? ??????? */}
      <Dialog open={closeProjectDialogOpen} onClose={handleCloseProjectClose}>
        <DialogTitle> {selectedRequest?.status === 'Closed' ? 'Download Project' : 'Finish the Project'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedRequest?.status === 'Closed'
              ? 'Do you want to download the project details as a PDF?'
              : 'Do you really want to finish this project?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <TextCancelButton onClick={handleCloseProjectClose}>Cancel</TextCancelButton>
          {selectedRequest?.status === 'Closed' ? (
            <ProjectVioletButton onClick={handleDownloadProject}>
              Download Project
            </ProjectVioletButton>
          ) : (
            <ProjectVioletButton onClick={handleConfirmCloseProject}>
              Finish the Project
            </ProjectVioletButton>
          )}
        </DialogActions>
      </Dialog>


      {/* ?????? ???????? ?????? */}
      <Dialog open={sendMailDialogOpen} onClose={() => setSendMailDialogOpen(false)} fullWidth maxWidth="sm">
  <DialogTitle>Send Mail</DialogTitle>
  <DialogContent  sx={{
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  }}>
    {/* ????? ???? "From" */}
    <FormControl fullWidth margin="normal" variant="standard">
      <InputLabel id="mail-from-label">From</InputLabel>
      <Select
        labelId="mail-from-label"
        value={mailFrom}
        onChange={(e) => setMailFrom(e.target.value)}
      >
        {emailAccounts.map(acc => (
          <MenuItem key={acc._id} value={acc.email}>
            {acc.email}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <TextField
      label="To"
      fullWidth
      margin="normal"
      value={mailRecipient}
      onChange={(e) => setMailRecipient(e.target.value)}
      placeholder="Enter recipient email"
    />
    <TextField
      label="Subject"
      fullWidth
      margin="normal"
      value={mailSubject}
      onChange={(e) => setMailSubject(e.target.value)}
      placeholder="Enter subject"
    />
    <TextField
      label="Email Content"
      fullWidth
      margin="normal"
      multiline
      minRows={6}
      value={mailBody}
      onChange={(e) => setMailBody(e.target.value)}
      placeholder="Enter email content here..."
    />
    {/* ??????? drag & drop ??? ?????? */}
    <Box sx={{ mt: 2 }}>
      <Box
  component="label"
  onDrop={handleDrop}
  onDragOver={handleDragOver}
  sx={{
    width: '100%',
    boxSizing: 'border-box',
    border: '2px dashed #ccc',
    borderRadius: 1,
    p: 2,
    textAlign: 'center',
    cursor: 'pointer',
    display: 'block',
    // ???????? ??? ?????????????:
    // maxWidth: '100%',
    // overflow: 'hidden',
    marginTop: 2, // ?????? mt: 2, ???? ?????? ????? ????? ????????
  }}
>
  <Typography variant="body2" color="textSecondary">
    Drag and drop files here, or click to attach files.
  </Typography>
  <input type="file" hidden multiple onChange={handleSendMailFileChange} />
</Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
        Note: The email will be sent using our default template.
      </Typography>
    </Box>
    {/* ?????? ????????????? ?????? */}
    {attachedFiles.length > 0 && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
        {attachedFiles.map((file, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #ccc',
              borderRadius: 1,
              p: 1
            }}
          >
            <Typography variant="body2" sx={{ mr: 1 }}>
              {file.name}
            </Typography>
            <IconButton size="small" onClick={() => handleRemoveSendMailFile(index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <TextCancelButton onClick={() => setSendMailDialogOpen(false)} disabled={sendingMail}>Cancel</TextCancelButton>
    <ThemePrimaryButton 
      onClick={handleSendMail}
      disabled={sendingMail}
    >
      {sendingMail ? 'Sending...' : 'Send'}
    </ThemePrimaryButton>
  </DialogActions>
</Dialog>

      {/* ?????? ?????????????? ??????? */}
      <Dialog 
        open={detailDialogOpen} 
        onClose={handleDetailClose} 
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: '60%'
          }
        }}
      >
        <DialogTitle>
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography>Edit Request</Typography>

    {/* ?????? Select � �??????�-????? ?? ???????? */}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {(() => {
        // ??????? ?????? ?? ??????? ?? ???????? ???????
        const currentOption =
          statusOptions.find((opt) => opt.value === formData.status) || {
            label: formData.status,
            icon: null,
          };

        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: statusColors[formData.status]?.background || 'rgba(0, 0, 0, 0.1)',
              color: statusColors[formData.status]?.text || '#000',
              px: 2,
              py: 1,
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            {currentOption.icon && (
              <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                {currentOption.icon}
              </Box>
            )}
            <Typography variant="body1" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
              {currentOption.label}
            </Typography>
          </Box>
        );
      })()}
    </Box>
  </Box>
</DialogTitle>
        <DialogContent dividers>
  {formData.status === 'Closed' && (
    <Box sx={{ 
      width: '100%', 
      bgcolor: '#f8f9fa', 
      p: 2, 
      mb: 2, 
      borderRadius: 1, 
      border: '1px solid #e0e0e0',
      display: 'flex',
      alignItems: 'center',
      gap: 1
    }}>
      <CloseIcon sx={{ color: '#757575' }} />
      <Typography variant="body2" sx={{ color: '#757575' }}>
        This project is closed and cannot be edited. You can download the project details or view its history.
      </Typography>
    </Box>
  )}
  <Box 
    component="form" 
    onSubmit={handleUpdateSubmit} 
    noValidate 
    sx={{ 
      mt: 1,
      opacity: formData.status === 'Closed' ? 0.8 : 1,
      position: 'relative'
    }}
  >
    <Section title="Client Information">
      <TextField
        name="firstName"
        label="First name"
        fullWidth
        required
        disabled={!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.firstName}
      />
      <TextField
        name="lastName"
        label="Last name"
        fullWidth
        required
        disabled={!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.lastName}
      />
      <TextField
        name="companyName"
        label="Company name"
        fullWidth
        disabled={!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.companyName}
      />
      <TextField
        name="phoneNumber"
        label="Phone number"
        fullWidth
        required
        disabled={!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.phoneNumber}
      />
      <TextField
        name="email"
        label="Email address"
        fullWidth
        required
        disabled={!canEditRequest(selectedRequest, user, isEditMode) && !isEditMode}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.email}
      />
    </Section>

    <Section title="Project Name">
      <TextField
        name="projectName"
        label="Project Name"
        fullWidth
        required
        disabled={!canEditRequest(selectedRequest, user, isEditMode)}
        sx={{ 
          mb: 2,
          "& .Mui-disabled": {
            "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
          }
        }}
        onChange={handleChange}
        value={formData.projectName}
      />
    </Section>

            <Section title="Choose a Service">
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Choose a Service</InputLabel>
                <Select name="chosenService" value={formData.chosenService} onChange={handleChange} label="Choose a Service" required disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                  <MuiMenuItem value="Digital-marketing">Digital-marketing</MuiMenuItem>
                  <MuiMenuItem value="Web & UX/UI & Graphic design">Web & UX/UI & Graphic design</MuiMenuItem>
                  <MuiMenuItem value="SEO">SEO</MuiMenuItem>
                  <MuiMenuItem value="Web development">Web development</MuiMenuItem>
                  <MuiMenuItem value="Complete Business Setup">Complete Business Setup</MuiMenuItem>
                </Select>
              </FormControl>
              
            </Section>

            {formData.chosenService === "Digital-marketing" && (
              <>
                <Section title="Marketing Service">
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Service Selection</InputLabel>
                    <Select name="serviceSelection" value={formData.serviceSelection} onChange={handleChange} label="Service Selection" required disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                      {services.map(service => (
                        <MuiMenuItem key={service} value={service}>
                          {service}
                        </MuiMenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Campaign Objective</InputLabel>
                    <Select name="campaignObjective" value={formData.campaignObjective} onChange={handleChange} label="Campaign Objective" disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                      {objectives.map(objective => (
                        <MuiMenuItem key={objective} value={objective}>
                          {objective}
                        </MuiMenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Section>

                <Section title="Target Audience">
                  <Autocomplete
                    multiple
                    options={countriesList}
                    getOptionLabel={(option) => option}
                    filterSelectedOptions
                    onChange={handleAutocompleteChange('countries')}
                    value={formData.countries}
                    disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="Country(ies)" placeholder="Select countries..." / >
                    )}
                    sx={{ mb: 2, width: '100%' }}
                  />
                  <Autocomplete
                    multiple
                    options={filteredCities}
                    getOptionLabel={(option) => option.name}
                    filterSelectedOptions
                    onChange={handleAutocompleteChangeForCities}
                    disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                    value={filteredCities.filter(cityObj => formData.cities.includes(cityObj.name))}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="City(ies)" placeholder={formData.countries.length > 0 ? "Select cities..." : "Select country first"} />
                    )}
                    sx={{ mb: 2, width: '100%' }}
                  />
                  <MultiSelectField
                    label="Age Range"
                    options={ageRanges}
                    value={formData.ageRange}
                    onChange={handleMultiSelectChange('ageRange')}
                    disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                    sx={{ 
                      "& .Mui-disabled": {
                        "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
                      }
                    }}
                  />
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Gender</InputLabel>
                    <Select name="gender" value={formData.gender} onChange={handleChange} label="Gender" disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                      {genders.map(g => (
                        <MuiMenuItem key={g} value={g}>
                          {g}
                        </MuiMenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Section>

                <Section title="Keywords">
                  <TextField name="keywords" label="Keywords" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.keywords} disabled={!canEditRequest(selectedRequest, user, isEditMode)}/>
                </Section>

                <Section title="Campaign Details">
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <TextField 
                      name="approximateBudget" 
                      label="Approximate Budget" 
                      type="number" 
                      fullWidth 
                      onChange={handleChange} 
                      value={formData.approximateBudget}
                      disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                      sx={{ 
                        "& .Mui-disabled": {
                          "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
                        }
                      }}
                    />
                    <Autocomplete
                      options={currencies.sort((a, b) => {
                        const favorites = ['EUR', 'USD'];
                        const aFav = favorites.includes(a) ? 0 : 1;
                        const bFav = favorites.includes(b) ? 0 : 1;
                        if (aFav !== bFav) return aFav - bFav;
                        return a.localeCompare(b);
                      })}
                      groupBy={(option) =>
                        ['EUR', 'USD'].includes(option)
                          ? 'Popular'
                          : 'Search for your currency'
                      }
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          variant="outlined" 
                          label="Currency" 
                          placeholder="Search for your currency" 
                          disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                          sx={{ 
                            "& .Mui-disabled": {
                              "-webkit-text-fill-color": selectedRequest?.status === 'Closed' ? "rgba(0, 0, 0, 0.38)" : "inherit"
                            }
                          }}
                        />
                      )}
                      onChange={(event, newValue) =>
                        setFormData(prev => ({ ...prev, currency: newValue }))
                      }
                      value={formData.currency || ''}
                      sx={{ width: '100%' }}
                      disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                    />
                  </Box>
                  <TextField name="targetAudienceDescription" label="Target Audience Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.targetAudienceDescription} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Contact Database</InputLabel>
                    <Select name="contactDatabase" value={formData.contactDatabase} onChange={handleChange} label="Contact Database" disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                      {contactDatabases.map(db => (
                        <MuiMenuItem key={db} value={db}>
                          {db}
                        </MuiMenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Section>

                <Section title="Additional Information">
                  <TextField name="additionalMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.additionalMessage} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                </Section>
              </>
            )}

            {formData.chosenService === "Web & UX/UI & Graphic design" && (
              <>
                <Section title="Graphic Service">
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Graphic Service</InputLabel>
                    <Select name="graphicService" value={formData.graphicService} onChange={handleChange} label="Graphic Service" required disabled={!canEditRequest(selectedRequest, user, isEditMode)}>
                      <MuiMenuItem value="Web design">Web design</MuiMenuItem>
                      <MuiMenuItem value="UX/UI design">UX/UI design</MuiMenuItem>
                      <MuiMenuItem value="Graphic design">Graphic design</MuiMenuItem>
                    </Select>
                  </FormControl>
                </Section>

                {formData.graphicService && (
                  <Section title="Description">
                    <TextField name="graphicDescription" label="Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicDescription} required disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                    {(formData.graphicService === "Web design" ||
                      formData.graphicService === "UX/UI design") && (
                      <>
                        <TextField name="graphicWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite1} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                        <TextField name="graphicWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite2} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                        <TextField name="graphicWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite3} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                      </>
                    )}
                    <BrandOutlinedButton component="label" sx={{ mb: 2 }}>
                      Upload Files
                      <input type="file" hidden multiple onChange={handleFileChange('graphicFiles')} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                    </BrandOutlinedButton>
                    {formData.graphicFiles.length > 0 && (
                      <Box mt={2}>
                        {formData.graphicFiles.map((file, index) => (
                          <Box
                            key={index}
                            display="flex"
                            alignItems="center"
                            border="1px solid #ccc"
                            borderRadius="4px"
                            p={1}
                            mb={1}
                          >
                            {file.preview && file.type && file.type.startsWith('image/') ? (
                              <a href={file.preview} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={file.preview}
                                  alt="Preview"
                                  width={50}
                                  height={50}
                                  style={{ marginRight: 10 }}
                                />
                              </a>
                            ) : (
                              <a href={file.preview} target="_blank" rel="noopener noreferrer">
                                <Box sx={{ mr: 2 }}>
                                  {getIconByMimeType(file.type)}
                                </Box>
                              </a>
                            )}
                            <Typography variant="body2" sx={{ flexGrow: 1 }}>
                              <a href={file.preview} target="_blank" rel="noopener noreferrer">
                                {file.name}
                              </a>
                            </Typography>
                            <IconButton onClick={() => handleRemoveFile('graphicFiles', index)}>
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        ))}
                      </Box>
                      
                    )}
                  </Section>
                )}
              </>
            )}

            {formData.chosenService === "SEO" && (
              <Section title="Your Webpage">
                <TextField name="seoWebpage" label="Webpage" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.seoWebpage} required disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="seoDescription" label="Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.seoDescription} required disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
              </Section>
            )}

            {formData.chosenService === "Web development" && (
              <Section title="Web Development Details">
                <TextField name="webDevMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevMessage} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="webDevWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite1} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="webDevWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite2} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="webDevWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite3} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />

                <BrandOutlinedButton component="label" sx={{ mb: 2 }}>
                  Upload Files
                  <input type="file" hidden multiple onChange={handleFileChange('webDevFiles')} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                </BrandOutlinedButton>

                {formData.webDevFiles.length > 0 && (
                  <Box mt={2}>
                    {formData.webDevFiles.map((file, index) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        border="1px solid #ccc"
                        borderRadius="4px"
                        p={1}
                        mb={1}
                      >
                        {file.type && file.type.startsWith('image/') ? (
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            <img
                              src={file.preview}
                              alt="Preview"
                              width={50}
                              height={50}
                              style={{ marginRight: 10 }}
                            />
                          </a>
                        ) : (
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            <Box sx={{ mr: 2 }}>
                              {getIconByMimeType(file.type)}
                            </Box>
                          </a>
                        )}
                        <Typography variant="body2" sx={{ flexGrow: 1 }}>
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            {file.name}
                          </a>
                        </Typography>
                        <IconButton onClick={() => handleRemoveFile('webDevFiles', index)}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                )}
              </Section>
            )}

            {formData.chosenService === "Complete Business Setup" && (
              <Section title="Complete Business Setup Details">
                <TextField name="businessMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.businessMessage} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="businessWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite1} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="businessWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite2} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                <TextField name="businessWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite3} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />

                <BrandOutlinedButton component="label" sx={{ mb: 2 }}>
                  Upload Files
                  <input type="file" hidden multiple onChange={handleFileChange('businessFiles')} disabled={!canEditRequest(selectedRequest, user, isEditMode)} />
                </BrandOutlinedButton>

                {formData.businessFiles.length > 0 && (
                  <Box mt={2}>
                    {formData.businessFiles.map((file, index) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        border="1px solid #ccc"
                        borderRadius="4px"
                        p={1}
                        mb={1}
                      >
                        {file.type && file.type.startsWith('image/') ? (
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            <img
                              src={file.preview}
                              alt="Preview"
                              width={50}
                              height={50}
                              style={{ marginRight: 10 }}
                            />
                          </a>
                        ) : (
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            <Box sx={{ mr: 2 }}>
                              {getIconByMimeType(file.type)}
                            </Box>
                          </a>
                        )}
                        <Typography variant="body2" sx={{ flexGrow: 1 }}>
                          <a href={file.preview} target="_blank" rel="noopener noreferrer">
                            {file.name}
                          </a>
                        </Typography>
                        <IconButton onClick={() => handleRemoveFile('businessFiles', index)}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                )}
              </Section>
            )}

            {/* ???? Price (????? ?????? admin/manager) */}
            {isAdminOrManagerRole(user?.role) && (
              <Section title="Price & Deadline">
               <TextField
  name="price"
  label="Price"
  type="number"
  disabled={!canEditRequest(selectedRequest, user, isEditMode)}
  fullWidth
  sx={{ mb: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
  onChange={handleChange}
  value={formData.price}
/>
                <TextField
                  name="projectDeadline"
                  label="Project Deadline *"
                  type="datetime-local"
                  disabled={!canEditRequest(selectedRequest, user, isEditMode)}
                  fullWidth
                  required={formData.price > 0}
                  sx={{ mb: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
                  onChange={handleChange}
                  value={formData.projectDeadline ? new Date(formData.projectDeadline).toISOString().slice(0, 16) : ''}
                  helperText={formData.price > 0 ? "Required when price is set" : "Deadline for project completion"}
                />
              </Section>
            )}
            
            {/* Показываем срок готовности для обычных пользователей (read-only) */}
            {normalizeRole(user?.role) === ROLE_USER && formData.projectDeadline && (
              <Section title="Project Information">
                <TextField
                  label="Project Deadline"
                  fullWidth
                  disabled
                  sx={{ mb: 2, backgroundColor: '#f9f9f9', borderRadius: 1 }}
                  value={formData.projectDeadline ? new Date(formData.projectDeadline).toLocaleString() : 'Not set'}
                  helperText="This is when your project will be ready"
                />
              </Section>
            )}
          </Box>
          
           {/* ?????? ??? ?????????/??????? ??????? */}
    <Box sx={{ mt: 2 }}>
      <BrandOutlinedButton
        onClick={() => setShowHistory(prev => !prev)}
      >
        {showHistory ? 'Hide History' : 'Show History'}
      </BrandOutlinedButton>
    </Box>

    {/* ???? ???????, ????????? ? Collapse */}
    <Collapse in={showHistory} unmountOnExit sx={{ mt: 2 }}>
      <Section title={
  <Box display="flex" alignItems="center" justifyContent="space-between">
    <Typography variant="h5">Change History</Typography>
    <BrandButton onClick={handleDownloadHistory}>
      Download History
    </BrandButton>
  </Box>
}>
  {selectedRequest?.history?.map((entry, index) => (
    <Box key={index} sx={{ mb: 2, p: 1, bgcolor: "#f5f5f5", borderRadius: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {entry.changedBy || "Unknown user"} {"\u2022"}{" "}
        {new Date(entry.timestamp).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}
      </Typography>
      {(entry.changes || "").split(", ").map((change, i) => (
        <Typography key={i} variant="body2" sx={{ fontFamily: "monospace" }}>
          {change.replace('?', '?')}
        </Typography>
      ))}
    </Box>
  ))}
</Section>
    </Collapse>
        </DialogContent>
        <DialogActions sx={{ 
  display: 'flex', 
  justifyContent: 'space-between',
  padding: '16px 24px',
  backgroundColor: 'white',
  borderTop: '1px solid rgba(0, 0, 0, 0.12)'
}}>
  <Box sx={{ display: 'flex', gap: 2 }}>
    
    {formData.status !== 'Closed' && (isAdminRole(user.role) || normalizeRole(user.role) === ROLE_USER) && (
      <BrandButton 
        variant="contained" 
        primaryHover="light"
        startIcon={<CheckCircleIcon />}
        onClick={handleCloseProjectOpen}
      >
        Finish the Project
      </BrandButton>
    )}

    {/* Edit/Close Edit buttons for user */}
    {normalizeRole(user.role) === ROLE_USER && formData.status === 'Pending payment' && (
      <>
        {!isEditMode ? (
          <Button 
            variant="outlined" 
            onClick={() => setIsEditMode(true)}
            disabled={formData.paymentStatus === 'Paid'}
            sx={{
              borderColor: 'rgb(48, 2, 89)',
              color: 'rgb(48, 2, 89)',
              '&:hover': {
                borderColor: 'rgb(38, 2, 69)',
                backgroundColor: 'rgba(48, 2, 89, 0.04)'
              },
              '&.Mui-disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.26)'
              }
            }}
          >
            Edit Project
          </Button>
        ) : (
          <>
            <Button 
              variant="outlined"
              onClick={handleCloseEdit}
              sx={{
                borderColor: 'rgb(48, 2, 89)',
                color: 'rgb(48, 2, 89)',
                '&:hover': {
                  borderColor: 'rgb(38, 2, 69)',
                  backgroundColor: 'rgba(48, 2, 89, 0.04)'
                }
              }}
            >
              Close Edit
            </Button>
            {hasFormChanges && (
              <Button 
                variant="contained"
                onClick={() => setConfirmEditDialogOpen(true)}
                sx={{
                  backgroundColor: 'rgb(48, 2, 89)',
                  '&:hover': {
                    backgroundColor: 'rgb(38, 2, 69)'
                  }
                }}
              >
                Save Edit
              </Button>
            )}
          </>
        )}
      </>
    )}
  </Box>

  {/* Center price display and Pay button */}
  {normalizeRole(user.role) === ROLE_USER && formData.price && Number(formData.price) > 0 && (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: 2
    }}>
      <Typography 
        variant="h5" 
        sx={{ 
          fontWeight: 600,
          color: 'rgb(48, 2, 89)'
        }}
      >
        {`${formData.price}€`}
      </Typography>
      
      {/* Payment status display */}
      {formData.paymentStatus && (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          ml: 1,
          backgroundColor: formData.paymentStatus === 'Paid' ? '#e6f4ea' : '#fff3e0',
          borderRadius: 1,
          px: 1,
          py: 0.5
        }}>
          {formData.paymentStatus === 'Paid' && <CheckCircleIcon fontSize="small" sx={{ color: '#34a853', mr: 0.5 }} />}
          {formData.paymentStatus !== 'Paid' && <AccessTimeIcon fontSize="small" sx={{ color: '#fbbc05', mr: 0.5 }} />}
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {formData.paymentStatus}
          </Typography>
        </Box>
      )}
      
      {formData.paymentStatus !== 'Paid' && !isEditMode && (
        <Button
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            handlePayRequest(formData);
          }}
          sx={{
            backgroundColor: 'rgb(48, 2, 89)',
            '&:hover': {
              backgroundColor: 'rgb(38, 2, 69)'
            }
          }}
        >
          Pay
        </Button>
      )}
    </Box>
  )}

  {/* Admin/manager view with price and payment status */}
  {isAdminOrManagerRole(user.role) && formData.price && Number(formData.price) > 0 && (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: 2
    }}>
      <Typography 
        variant="h5" 
        sx={{ 
          fontWeight: 600,
          color: 'rgb(48, 2, 89)'
        }}
      >
        {`${formData.price}€`}
      </Typography>
      
      {/* Payment status display */}
      {formData.paymentStatus && (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          ml: 1,
          backgroundColor: formData.paymentStatus === 'Paid' ? '#e6f4ea' : '#fff3e0',
          borderRadius: 1,
          px: 1,
          py: 0.5
        }}>
          {formData.paymentStatus === 'Paid' && <CheckCircleIcon fontSize="small" sx={{ color: '#34a853', mr: 0.5 }} />}
          {formData.paymentStatus !== 'Paid' && <AccessTimeIcon fontSize="small" sx={{ color: '#fbbc05', mr: 0.5 }} />}
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {formData.paymentStatus}
          </Typography>
        </Box>
      )}
    </Box>
  )}

  {/* Right side - Save button */}
  <Box sx={{ display: 'flex', gap: 2 }}>
  <TextCancelButton 
      onClick={handleDetailClose}
      disabled={isEditMode}
    >
      Close
    </TextCancelButton>
    
    {(isAdminOrManagerRole(user.role) ||
      (normalizeRole(user.role) === ROLE_USER && formData.paymentStatus !== 'Paid' && formData.status !== 'Pending payment')) && (
      <ThemePrimaryButton 
        onClick={handleUpdateSubmit}
      >
        Save
      </ThemePrimaryButton>
    )}
  </Box>
</DialogActions>

      </Dialog>

      <PageSnackbars
        {...snackbarProps}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />

      {/* Add Project Dialog */}
      <Dialog 
        open={addProjectDialogOpen} 
        onClose={() => {
          setAddProjectDialogOpen(false);
          setErrorMessage(''); // Clear error message when closing dialog
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: '60%',
            backgroundColor: '#f5f5f5',
            '& .MuiDialogContent-root': {
              padding: '0px'
            }
          }
        }}
      >
        <Paper 
          elevation={2} 
          sx={{ 
            m: 3,
            p: 3,
            borderRadius: 2,
            backgroundColor: 'white'
          }}
        >
          <DialogContent>
            <RequestForm 
              onFormSubmit={() => {
                setAddProjectDialogOpen(false);
                fetchRequests(); // Refresh the requests list
              }}
              formRef={setFormRef}
              onSuccess={(message) => setSuccessMessage(message)}
              onError={(message) => setErrorMessage(message)}
            />
          </DialogContent>
        </Paper>
        <DialogActions 
          sx={{ 
            padding: '16px 24px',
            backgroundColor: 'white',
            borderTop: '1px solid rgba(0, 0, 0, 0.12)'
          }}
        >
          <TextCancelButton onClick={() => {
            setAddProjectDialogOpen(false);
            setErrorMessage(''); // Clear error message when closing dialog
          }}>Cancel</TextCancelButton>
          <Button 
            variant="contained" 
            onClick={handleAddProjectSubmit}
            sx={{ 
              backgroundColor: 'rgb(48, 2, 89)',
              '&:hover': {
                backgroundColor: 'rgb(38, 2, 69)'
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add confirmation dialog to the component */}
      {ConfirmEditDialog()}
    </Box>
  );
}
